<template>
  <div class="product-card" :class="{ 'with-promo' : !!(data.offer.text) }">
    <div class="card">
      <a :href="data.permalink" class="product-link"></a>
      <div class="promotion" :class="[data.offer.style]" v-if="data.offer.text && !data.tag">{{ data.offer.text }}</div>
      <div class="tag" v-if="data.tag && !data.offer.text">{{ data.tag }}</div>
      <div class="colors">
        <span class="color" v-for="(color, index) in data.colors" :key="index" :style="{ backgroundColor: '#' + color.hex }"></span>
      </div>
      <div class="picture">
        <img :src="data.pictures[0]" :alt="data.name" v-if="data.pictures.length && data.pictures[0]">
      </div>
      <div class="right">
        <div class="name">
          <h2>{{ data.name }}</h2>
          <div class="stock" v-if="store">
            <div class="st in-stock" v-if="data.stock && store"><span></span> Disponible en magasin</div>
            <div class="st out-of-stock" v-if="!data.stock && store"><span></span> Indisponible en magasin</div>
            <div class="store"><p>{{ storeName }}</p></div>
          </div>
        </div>
        <div class="price">
          <div class="price-package">
            <p class="amount" v-html="data.prices.display"></p>
            <p class="fraxio" v-if="data.fraxio.price">+{{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(data.fraxio.price) }} / mois x {{ data.fraxio.duration }} mois</p>
            <p class="subscription" v-if="data.subscription">Avec {{ data.subscription }}</p>
          </div>
          <div class="price-alone" v-if="data.subscription">
            <p>Prix seul : <span v-html="data.prices.alone"></span></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ProductCard',
  props: {
    data: Object
  },
  computed: {
    ...mapState({
      store: state => state.products.store,
      storeName: state => state.products.storeName
    }),
    storages () {
      const storages = []

      this.data.storages.forEach((item) => {
        if(item.capacite) {
          storages.push(item.capacite + ' ' + item.unit.toLowerCase())
        }
      })

      return storages
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/tools/*';
@import '../../../scss/mixins/*';

.product-card{
  position: relative;
  z-index: 0;
  width: 100%;
  height: auto;

  &:before, &:after{
    content: '';
    display: block;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    @include radius(10px);
    @include transition(All 0.15s);
  }

  &:before{
    height: 100%;
    z-index: -1;
    background-color: $white;
    border: 2px solid rgba($white, 0);
    @include box-shadow(0, 2px, 4px, rgba($black, 0.1));
  }

  &:after {
    height: 90%;
    background-color: $primary;
    opacity: 0;
    z-index: -2;
  }

  &:hover {

    .promotion{
      @include transform(translateY(-3px) translateX(-5px));
    }

    &:before{
      border: 2px solid $primary;
      @include transform(translateY(-3px) translateX(-5px));

      @include responsive(mobile) {
        border: 2px solid rgba($white, 0);
        @include transform(translateY(0) translateX(0));
      }
    }

    &:after {
      opacity: 1;
      @include transform(translateY(3px) translateX(3px));

      @include responsive(mobile) {
        opacity: 0;
        @include transform(translateY(0) translateX(0));
      }
    }
  }

  .card {
    position: relative;
    min-height: 520px;
    padding: 30px 30px 170px 35px;

    @include responsive(mobile) {
      display: grid;
      grid-template-columns: 100px 1fr;
      grid-column-gap: 20px;
      min-height: auto;
      padding: 20px 20px 10px 30px;
    }

    .promotion{
      position: absolute;
      left: 0;
      top: 150px;
      width: auto;
      background-color: $turquoise;
      color: $black;
      font-size: px2rem(13px);
      font-weight: $fontBold;
      z-index: 10;
      height: 30px;
      line-height: 30px;
      padding: 0 10px;
      border: 1px solid $white;
      border-left: 0;
      @include box-sizing();
      @include radius(18px, 'right');
      @include transition(All 0.15s);

      @include responsive(mobile){
        width: 100%;
        top: -5px;
        border: none;
        left: 2px;
        text-align: center;
        @include radius(18px);
        @include radius(0px, 'bottom-right');
      }

      &.yellow{
        background-color: $yellow;
      }
    }

    .tag{
      width: auto;
      position: absolute;
      right: 30px;
      top: 30px;
      background-color: $primary;
      color: $white;
      font-family: $headingsFont;
      font-size: px2rem(15px);
      font-weight: $fontMedium;
      z-index: 10;
      height: 30px;
      line-height: 30px;
      padding: 0 10px;
      @include box-sizing();
      @include radius(18px);

      @include responsive(mobile) {
        right: -10px;
        top: 30px;
      }
    }

    a.product-link {
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 10;
    }

    .colors {
      display: inline-block;
      position: absolute;
      left: 10px;
      top: 10px;
      width: 20px;
      height: auto;

      @include responsive(mobile) {
        top: 50%;
        left: -12px;
        @include transform(translateY(-50%));
      }

      span.color {
        display: inline-block;
        width: 14px;
        height: 14px;
        margin: 3px 3px 3px 5px;
        border: 1px solid darken($white, 20%);
        @include box-sizing();
        @include radius(100%);
      }
    }

    .picture {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 230px;
      margin-bottom: 20px;

      @include responsive(mobile) {
        margin-bottom: 0;
      }

      img {
        display: inline-block;
        width: auto;
        height: auto;
        max-width: 165px;
        max-height: 226px;

        @include responsive(mobile) {
          max-width: 200px;
          max-height: 150px;
        }
      }
    }

    .name{
      text-align: center;

      @include responsive(mobile) {
        padding-top: 10px;
        text-align: left;
      }

      h2 {
        display: block;
        width: 100%;
        font-size: px2rem(18px);
        line-height: px2rem(24px);
        font-weight: $fontSemiBold;
        color: $black;
        padding: 0;

        @include responsive(mobile) {
          font-size: px2rem(15px);
          line-height: px2rem(20px);
        }
      }

      .stock{
        margin-top: 3px;

        .st{
          font-size: px2rem(14px);
          line-height: px2rem(19px);

          span{
            display: inline-block;
            width: 8px;
            height: 8px;
            vertical-align: middle;
            margin-right: 2px;
            @include radius(100%);
            @include transform(translateY(-1px));
          }

          &.in-stock{
            color: $greenValidate;

            span{
              background-color: $greenValidate;
            }
          }

          &.out-of-stock{
            color: $red;

            span{
              background-color: $red;
            }
          }
        }

        .store{
          p{
            font-size: px2rem(13px);
            line-height: px2rem(18px);
          }
        }
      }
    }

    .storages{
      text-align: center;

      @include responsive(mobile) {
        margin-top: 5px;
        text-align: left;
      }

      span.storage{
        display: inline-block;
        height: 24px;
        line-height: 20px;
        padding: 0 5px;
        margin: 5px;
        border: 2px solid rgba($black, 0.1);
        text-transform: capitalize;
        font-weight: $fontBold;
        @include box-sizing();
        @include radius(3px);

        @include responsive(mobile) {
          margin-left: 0;
          margin-top: 0;
        }
      }
    }

    .price{
      position: absolute;
      bottom: 30px;
      left: 0;
      padding: 0 30px;

      @include responsive(mobile) {
        position: relative;
        bottom: initial;
        left: initial;
        padding: 0;
        grid-column: span 2;
        text-align: left;
      }

      .price-package{
        text-align: center;

        @include responsive(mobile) {
          text-align: left;
        }

        p.amount{
          padding: 20px 0 5px 0;
          text-transform: none;
          color: $primary;
          font-weight: $fontSemiBold;
          font-size: px2rem(28px);

          @include responsive(mobile) {
            padding: 20px 0 5px 0;
            font-size: px2rem(24px);
          }
        }

        p.fraxio{
          margin-bottom: 10px;
          font-size: px2rem(12px);
          line-height: px2rem(18px);
        }

        p.subscription{
          display: inline-block;
          padding: 0 0 20px 0;
          max-width: 200px;
          line-height: px2rem(18px);
          float: none;

          @include responsive(mobile) {
            font-size: px2rem(13px);
            line-height: px2rem(18px);
          }
        }
      }

      .price-alone{
        text-align: center;

        @include responsive(mobile) {
          text-align: left;
        }

        p{
          font-size: px2rem(14px);
          color: rgba($black, 0.8);
          text-transform: none;
          line-height: px2rem(16px);
          margin: 0 auto;

          @include responsive(mobile) {
            font-size: px2rem(13px);
            line-height: px2rem(18px);
          }

          span{
            font-weight: $fontSemiBold;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
@import '../../../scss/tools/*';
@import '../../../scss/mixins/*';

.product-card{
  .price-package{
    p.amount{
      span{
        sub{
          display: inline-block;
          vertical-align: top;
          font-size: px2rem(15px);
        }
      }
    }
  }
  .price-alone{
    p{
      span{
        sub{
          display: inline-block;
          vertical-align: top;
          @include transform(translateY(-1px));
        }
      }
    }
  }
}
</style>
